/* generated file, changes will be overwritten */
/** @public */
export const name: string = "html-validate";
/** @public */
export const version: string = "8.18.2";
/** @public */
export const homepage: string = "https://html-validate.org";
/** @public */
export const bugs: string = "https://gitlab.com/html-validate/html-validate/issues/new";
